import { useEffect } from "react";

/**
 * MaterialIcon - Replacement for material-icons-react using Google Material Symbols
 * This component uses Google Material Symbols font instead of the deprecated material-icons-react package
 */
const MaterialIcon = (props) => {
    const {
        icon,
        size = "small",
        className = "",
        color,
        title = "",
        onClick,
        style = {},
        ...restProps
    } = props;

    // Load Material Symbols font if not already loaded
    useEffect(() => {
        const linkId = 'material-symbols-font';
        if (!document.getElementById(linkId)) {
            const link = document.createElement('link');
            link.id = linkId;
            link.rel = 'stylesheet';
            link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
            document.head.appendChild(link);
        }
    }, []);

    // Map size prop to fontSize
    const sizeMap = {
        "small": "18px",
        "medium": "24px",
        "large": "36px"
    };
    const fontSize = sizeMap[size] || "24px";

    // Determine font weight based on props
    const fontWeight = props.bold ? 400 : 200;

    const iconStyle = {
        fontVariationSettings: `'FILL' 1, 'wght' ${fontWeight}, 'GRAD' 0, 'opsz' 24`,
        fontFamily: "'Material Symbols'",
        fontSize: fontSize,
        verticalAlign: 'middle',
        display: 'inline-block',
        cursor: 'pointer',
        ...(color && { color: color }), // Only apply color if explicitly provided
        ...style
    };

    return (
        <span
            className={`material-symbols ${className}`}
            style={iconStyle}
            title={title}
            onClick={onClick}
            {...restProps}
        >
            {icon}
        </span>
    );
};

export default MaterialIcon;

